import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel } from "swiper/modules";
import { usePopup } from "hooks/usePopup";
import { viewCounterOffer, viewOffer } from "services/offersService";
import PageHeaderUserNotificationClose from "./PageHeaderUserNotificationClose";

const NotificationsList = ({ list, clearNotification }) => {
  const swiperRef = useRef(null);
  const setPopupHook = usePopup();

  const getTagClass = (payload) => {
    if (payload.CounterOfferId) {
      return "counter";
    } else if (payload.ListingId) {
      return "marketplace";
    }
  };

  const isViewOffer = (type, payload) => {
    const { OfferId, CounterOfferId, ExpireTime } = payload;

    const rightNow = new Date();
    const expired_at = new Date(ExpireTime);
    const isAvailable = rightNow < expired_at;

    if (
      (type === "offer_made" || type === "counter_offer_made") &&
      isAvailable
    ) {
      return (
        <footer className="page-header__notification-actions">
          <button
            className="page-header__notification-view"
            onClick={() => {
              if (OfferId) {
                viewOffer(OfferId, setPopupHook);
              } else {
                viewCounterOffer(CounterOfferId, setPopupHook);
              }
            }}
          >
            View
          </button>
        </footer>
      );
    }
  };

  const formattingNotificationDate = (createdAt) => {
    const createdTime = new Date(createdAt);
    const now = new Date();
    const timeDiff = now - createdTime;

    const totalSeconds = Math.floor(timeDiff / 1000);

    if (totalSeconds < 60) {
      return "just now";
    } else if (totalSeconds < 3600) {
      const minutes = Math.floor(totalSeconds / 60);
      return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
    } else if (totalSeconds < 86400) {
      const hours = Math.floor(totalSeconds / 3600);
      return `${hours} hour${hours === 1 ? "" : "s"} ago`;
    } else if (totalSeconds < 2592000) {
      const days = Math.floor(totalSeconds / 86400);
      return `${days} day${days === 1 ? "" : "s"} ago`;
    } else {
      const months = Math.floor(totalSeconds / 2592000);
      return `${months} month${months === 1 ? "" : "s"} ago`;
    }
  };

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.update();
    }
  }, [list])

  return (
    <Swiper
      onSwiper={(swiper) => {
        swiperRef.current = swiper;
      }}
      className="page-header__user-popup-slider"
      direction={"vertical"}
      slidesPerView={"auto"}
      freeMode={true}
      mousewheel={{
        releaseOnEdges: true
      }}
      modules={[FreeMode, Mousewheel]}
    >
      <SwiperSlide>
        <ul className="page-header__notifications">
          {list.map((item) => {
            const { id, message, type, created_at, payload } = item;

            return (
              <li className="page-header__notification" key={id}>
                <PageHeaderUserNotificationClose
                  id={id}
                  clearNotification={clearNotification}
                />
                <span
                  className={`page-header__notification-type ${getTagClass(
                    payload
                  )} `}
                >
                  {payload.CounterOfferId && "Counter Offer"}
                  {payload.OfferId && "Offer"}
                  {payload.ListingId && "Marketplace"}
                  {payload.PredictionId && 'Prediction'}
                </span>
                <p className="page-header__notification-text">{message}</p>
                <span className="page-header__notification-date">
                  {formattingNotificationDate(created_at)}
                </span>
                {isViewOffer(type, payload)}
              </li>
            );
          })}
        </ul>
      </SwiperSlide>
    </Swiper>
  );
};

export default NotificationsList;
